import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withMemo as _withMemo, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "header w-100 pa-1 shadow-sm display-none-media-768" }
const _hoisted_2 = { class: "mw-1160 d-flex m-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex direction-row a-i-center p-2" }, null, -1)
const _hoisted_4 = { class: "d-flex direction-row a-i-center discount-container j-content-center w-100" }
const _hoisted_5 = {
  key: 1,
  class: "text-motserrat-15 t-white text-nowrap ml-2 mr-2"
}
const _hoisted_6 = ["value"]

import { Locations } from "@/store/modules/Locations/type";
import { Costumers } from "@/store/modules/Customers/type";
import { Currency } from "@/store/modules/Currency/type";
import { computed, ref, watch, watchEffect } from "vue";
import { logoutUser } from "@/utils/logout/logoutUser";
import { IStore } from "../../store/types/StoreType";
import { i18n } from "@/plugins/i18n";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  setup(__props) {

const store = useStore<IStore>();
const language = ref(store.getters.getAllLanguage);
const token = ref(computed<string>(() => store.getters.accessTokenGet));
const tokenLoading = ref(computed<boolean>(() => store.getters.loadingGet));
const userLanguage = ref(computed<string>(() => store.getters.getUserUiLang));

const locationLoading = ref(
  computed<boolean>(() => store.getters.getCustomerLocationLoading)
);
const locationCustomer = ref(
  computed<Locations[]>(() => store.getters.getLocationsCustomerById)
);

const currencies = ref(
  computed<Currency[]>(() => store.getters.getAllCurrencies)
);
const selectedCurrencies = ref<string>(
  store.getters.getSelectedCurrency || "EUR"
);

const languageSave = ref([null, "English", "Finland", "Swedish"]);

const updateLanguage = (event: EventTarget | null) => {
  if (!event) return;
  const element = event as HTMLInputElement;

  let lang = element.value;
  if (!lang) return;
  if (lang === "Finnish") lang = "Finland";
  store.dispatch("updateLanguage", languageSave?.value?.indexOf(lang));
};

const updateCurrencies = (event: EventTarget | null) => {
  if (!event) return;
  const element = event as HTMLInputElement;

  const curr = element.value;

  if (!curr) return;

  store.dispatch("updatedCurrenciesSelected", curr);
};

watch(
  () => userLanguage.value,
  () => {
    i18n.global.locale = languageSave?.value?.find(
      (_) => _ === userLanguage.value
    );
  }
);

watch(
  () => currencies.value,
  () => {
    const userCustomer: Costumers[] = store.getters?.getUserCustomerData;

    if (!userCustomer || userCustomer?.length <= 0) return;

    store.commit("updateSelectedCurrency", userCustomer[0]?.currency);
  },
  {
    deep: true,
  }
);

const watchCurrency = watchEffect(() => {
  if (store.getters?.getSelectedCurrency) {
    selectedCurrencies.value = store.getters?.getSelectedCurrency;
    watchCurrency();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (token.value && token.value?.length > 0)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: "text-motserrat-15 t-white text-nowrap pointer ml-2 mr-2 logout",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(logoutUser) && _unref(logoutUser)(...args)))
            }, _toDisplayString(_ctx.$tc("Logout")), 1))
          : _createCommentVNode("", true),
        (token.value && token.value?.length > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$tc(_unref(store).getters.getUserCustomerTypeData || "No info")), 1))
          : _createCommentVNode("", true),
        (_unref(store).getters.getUserCustomerTypeData !== 'Distributor')
          ? _withMemo([
            _unref(store).getters.getUserCustomerTypeData,
            (locationCustomer.value || [])[0]?.geo_place_country,
            locationLoading.value,
            tokenLoading.value,
          ], () => (_openBlock(), _createElementBlock("p", {
              key: 2,
              class: "text-motserrat-15 t-white location text-center j-content-centerml-2 ml-2 mr-2 no-select display-none"
            }, [
              _createTextVNode(_toDisplayString(locationLoading.value || tokenLoading.value
              ? "Loading..."
              : (locationCustomer.value || [])[0]?.geo_place_country), 1)
            ])), _cache, 1)
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.$i18n.locale) = $event)),
          class: "select text-motserrat-15 text-center t-white lang",
          onInput: _cache[3] || (_cache[3] = ($event: any) => (updateLanguage($event.currentTarget)))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(language.value, (lang) => {
            return (_openBlock(), _createElementBlock("option", {
              value: lang,
              key: `Lang${lang}`
            }, _toDisplayString(lang === "Finland"
                ? "Suomi"
                : lang === "Swedish"
                ? "Svenska"
                : lang), 9, _hoisted_6))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.$i18n.locale]
        ]),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedCurrencies).value = $event)),
          onChange: _cache[5] || (_cache[5] = ($event: any) => (updateCurrencies($event.currentTarget))),
          class: "select text-motserrat-15 text-center t-white ml-2 mr-2"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currencies.value, (currency) => {
            return (_openBlock(), _createElementBlock("option", {
              key: currency?.id
            }, _toDisplayString(currency?.code), 1))
          }), 128))
        ], 544), [
          [_vModelSelect, selectedCurrencies.value]
        ])
      ])
    ])
  ]))
}
}

})